import axios from 'axios'

const baseurl = process.env.REACT_APP_API_URL

export const getHomeCategories = async () => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/getCategory`
  })
  return res.data?.data?.categories
}

export const getSubCategory = async type => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/getSubCategory?type=${type}`
  })
  return res.data?.data?.categories
}
